<template>
  <div id="app" class="main_content">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue';
import "./assets/css/reset.css";
import VueResource from 'vue-resource';
import VueLazyload from 'vue-lazyload';
Vue.use(VueResource);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
})
export default {
  name: 'app',
  created(){
    var docEl = document.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function() {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
                docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
            self.isEmputy =true;
        };

    if (!document.addEventListener) return;
    window.addEventListener(resizeEvt, recalc, false);
    document.addEventListener('DOMContentLoaded', recalc, false);
  },
  watch:{


  }

}
</script>

<style>
#app {
  height: 100%;
  width: 100%;
  
}
</style>



// WEBPACK FOOTER //
// App.vue?7db477d7